require('./expensesByCategoryTabs.scss');
require('./expensesByCategoryTabsBlock.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const classNames = require('classnames');

// @ utils
const { formatText } = require('core/i18n').i18n;

// @common
const ComparativeBar = require('components/commons/comparativeBar/comparativeBar');
const OKCarousel = require('components/commons/OKCarousel/OKCarousel');

// @helpers
const { getFirstNChars } = require('utilities/stringHelper');

// @constants
const { getCategoryIcon } = require('constants/categories');

class ExpensesByCategoryTabs extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            currentSlider: 0
        };

        this.handleNext = this.handleNext.bind(this);
        this.handlePrevious = this.handlePrevious.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const firsTab = nextProps.categories.indexOf(nextProps.selectedTab);
        this.setState({ currentSlider: firsTab });
    }

    handleNext() {
        this.slider.slickNext();
    }

    handlePrevious() {
        this.slider.slickPrev();
    }

    handleCategoryChange(category) {
        this.props.onChangeCategory(category);
    }

    getBlocks() {
        const { totalExpenses, totalCategoryExpenses, selectedTab, categories, blue } = this.props;

        return(
            categories.map((item, index) => {

                const finalBlockClass = classNames('expenses-by-category-tabs-block', {
                    'expenses-by-category-tabs-block--selected': item === selectedTab
                });

                const iconClasses = classNames(
                    'expenses-by-category-tabs-block__icon',
                    getCategoryIcon(item)
                );
                const expenses = totalCategoryExpenses ? totalCategoryExpenses.get(item) : 0;
                let categoryName = formatText('categories-'+item);
                let categoryNameLimit = 18;

                if (categoryName.length > categoryNameLimit) {
                    categoryName = getFirstNChars(categoryName, categoryNameLimit);
                }

                return (
                    <div key={index} className={finalBlockClass} onClick={() => this.handleCategoryChange(item)}>
                        <div className="expenses-by-category-tabs-block__category-name-wrapper">
                            <i className={iconClasses} />
                            <span className="expenses-by-category-tabs-block__category-name">{categoryName}</span>
                        </div>
                        <div className="expenses-by-category-tabs-block__bar-wrapper">
                            <ComparativeBar
                                slim
                                blue={blue}
                                firstValue={expenses}
                                totalValue={totalExpenses}
                                className="expenses-by-category-tabs-block__bar"
                            />
                        </div>
                    </div>
                );
            })
        );
    }

    render() {
        //const { categories } = this.props;
        const { currentSlider } = this.state;
        const blocks = this.getBlocks();
        const tabsPerClick = 5;

        const settings = {
            className: 'expenses-by-category-tabs__carousel',
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: tabsPerClick,
            slidesToScroll: tabsPerClick,
            draggable: false,
            arrows: false,
            initialSlide: currentSlider
        };

        return (
            <div className="expenses-by-category-tabs">
                <OKCarousel
                    numberSlides={this.props.categories.length}
                    settings={settings}
                    blocks={blocks}
                    leftButtonClass="expenses-by-category-tabs__left-button"
                    rightButtonClass="expenses-by-category-tabs__right-button"
                    leftIcon="icon-breadcrumb"
                    rightIcon="icon-breadcrumb"
                    customInitial
                    />
            </div>
        );
    }
}

ExpensesByCategoryTabs.propTypes = {
    categories: PropTypes.array.isRequired,
    onChangeCategory: PropTypes.func.isRequired,
    selectedTab: PropTypes.string.isRequired,
    totalExpenses: PropTypes.number,
    totalCategoryExpenses: PropTypes.object,
    blue: PropTypes.bool
}

module.exports = ExpensesByCategoryTabs;
